import IconAmex from '~/svg/colorfulPayments/IconAmex.svg';
import IconApplePay from '~/svg/colorfulPayments/IconApplePay.svg';
import IconBitcoin from '~/svg/colorfulPayments/IconBitcoin.svg';
import IconEtherium from '~/svg/colorfulPayments/IconEtherium.svg';
import IconGooglePay from '~/svg/colorfulPayments/IconGooglePay.svg';
import IconMastercard from '~/svg/colorfulPayments/IconMastercard.svg';
import IconPaypal from '~/svg/colorfulPayments/IconPaypalF.svg';
import IconVisa from '~/svg/colorfulPayments/IconVisa.svg';
import IconShield from '~/svg/IconShield.svg';

type PaymentMethodsProps = {
  title?: string;
  description?: string;
};

export function PaymentMethods({ title, description }: PaymentMethodsProps) {
  return (
    <div className='m:flex-row m:items-center m:justify-between flex w-full flex-col gap-6 text-left'>
      <div className='flex items-center gap-4'>
        <div className='text-neutral-N40 gap-1 text-left'>
          <div className='flex items-center gap-3'>
            <IconShield className=' max-w-4' />

            <p className='text-body-m'>{title}</p>
          </div>
          <p className='text-body-s'>{description}</p>
        </div>
      </div>
      <div className='flex items-center gap-2'>
        <IconVisa />
        <IconMastercard />
        <IconAmex />
        <IconPaypal />
        <IconApplePay />
        <IconGooglePay />
        <IconBitcoin />
        <IconEtherium />
      </div>
    </div>
  );
}
